<!-- Index-1 component -->
<script>
  import { Modal, ModalBody, ModalHeader } from "sveltestrap";
  import Navbar from "../Components/Navbar.svelte";

  import Services from "../Components/Services.svelte";
  import Features from "../Components/Features.svelte";
  import Pricing from "../Components/Pricing.svelte";
  import Team from "../Components/Team.svelte";
  import Testimonial from "../Components/Testimonial.svelte";
  import Blog from "../Components/Blog.svelte";
  import Contact from "../Components/Contact.svelte";
  import Footer from "../Components/Footer.svelte";
  import Switcher from "../Components/Switcher.svelte";

  import data from "../Data/data";
    import Supporter from "../Components/Supporter.svelte";

  let open = false;
  /**
   * Toggle modal
   */
  const toggle = () => {
    open = !open;
  };

</script>

<!-- STRAT NAVBAR -->
<Navbar />
<!-- END NAVBAR -->
<!--START HOME-->

<section
  class="section bg-home home-half active common-section"
  id="home"
  data-image-src="images/bg-home.jpg"
>
  <div class="bg-overlay" />
  <div class="display-table">
    <div class="display-table-cell">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-white text-center">
            <h1 class="home-title">Elevate your online presence with our SEO expertise.</h1>
            <p class="pt-3 home-desc">
              Get found. Get noticed. Get business.
            </p>
            <a href="{'#contact'}" class="btn btn-primary mt-4 waves-effect waves-light"
            >Book an Appointment</a
          >
          
            <!-- <ul class="list-inline social mt-4">
              <li class="list-inline-item">
                <a href={"https://www.facebook.com/kritanp77"} class="social-icon"><i class="mdi mdi-facebook" /></a>
              </li>
              <li class="list-inline-item">
                <a href={"https://www.instagram.com/kritan_pandey/"} class="social-icon"><i class="mdi mdi-instagram" /></a>
              </li>
              <li class="list-inline-item">
                <a href={"https://www.linkedin.com/in/kritanpandey7/"} class="social-icon"><i class="mdi mdi-linkedin" /></a>
              </li>
              <li class="list-inline-item">
                <a href={"https://www.youtube.com/@kritan55"} class="social-icon"
                  ><i class="mdi mdi-youtube" /></a
                >
              </li>
              
            </ul> -->
       
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="bg-pattern-effect">
    <img src="images/bg-pattern.png" alt="" />
  </div>
</section>


<!--END HOME-->

<Services serviceData={data.SERVICE_DATA} />
<Features featureData={data.FEATURES_DATA} />

<!-- <Pricing pricingData={data.PRICING_DATA} />  -->
<Team teamData={data.TEAM_DATA} />
<Testimonial testimonialData={data.TESATIMONIAL_DATA} />
<Blog blogData={data.BLOG_DATA} />
<!-- <Supporter /> -->
<Contact />
<Footer />
<Switcher />
